module.exports = __webpack_public_path__ + "img/section-voice-phone.76fd497b.png";